import { Box } from "@mui/material";
import { CreateButton } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { FilterDropdown } from "@shared/components";
import {
  PartnerListFilters,
  RejectModal,
  SummaryCards,
} from "@modules/partners/components";
import { formatCurrency } from "@core/utils/masks";

import { usePartnersTab } from "./controller";
import { usePartnersColumns } from "./columns";

export function PartnersTab() {
  const {
    rows,
    loading,
    tableProps,
    summary,
    rejectTarget,
    isRejecting,
    setRejectTarget,
    handleApprove,
    handleReject,
    refetch,
    translate,
  } = usePartnersTab();

  const columns = usePartnersColumns({
    translate,
    refetch,
    onApprove: handleApprove,
    onReject: setRejectTarget,
  });

  return (
    <>
      {summary && (
        <Box sx={{ mb: 2 }}>
          <SummaryCards
            items={[
              {
                label: translate("v1/partner_admin.fields.referrals_count"),
                value: summary.referrals_count,
              },
              {
                label: translate("v1/partner_admin.fields.total_mrr"),
                value: formatCurrency(summary.total_mrr),
              },
              {
                label: translate("v1/partner_admin.fields.total_commission"),
                value: formatCurrency(summary.total_commission),
              },
            ]}
          />
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}>
        <FilterDropdown initialValues={{ search: "", status: "" }}>
          <PartnerListFilters />
        </FilterDropdown>
        <CreateButton resource="v1/partner_admin" />
      </Box>

      <DataGrid {...tableProps} rows={rows} columns={columns} loading={loading} />

      <RejectModal
        open={Boolean(rejectTarget)}
        loading={isRejecting}
        onClose={() => setRejectTarget(null)}
        onConfirm={handleReject}
      />
    </>
  );
}
